var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),_c('b-container',{staticStyle:{"margin-top":"40px"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }